<template>
  <div>
    <modal centered :show.sync="localOpen" id="addAudiance" bodyClasses="create-campaign-modal-body"
      footerClasses="border-top p-2">
      <div slot="header"><span class="p-3 d-block"></span></div>
     <div class="pb-3 w-100 d-flex align-items-center justify-content-between col-sm-12 col-md-12 col-lg-12 row">
        <h3 class="title title-up m-0" style="color: #222a42 !important;">
          Media Storage
        </h3>
       <div class="d-flex align-items-center" style="gap: 8px;">
          <el-upload ref="upload" class="audiance-upload" accept="image/jpeg,image/png,image/gif" :auto-upload="false"
            :show-file-list="false" :on-change="handleChange">
            <el-button type="primary" icon="el-icon-upload2">Upload Media</el-button>
          </el-upload>
          <el-dropdown trigger="click">
            <span class="menu-drop-anchor">
              <el-button icon="el-icon-more"></el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div @click.stop="" class="d-flex align-items-center text-dark px-3" style="gap: 12px; font-size: 14px;">
                <span><i class="fa-regular fa-cloud" style="margin-right: 4px;"></i>Storage Used</span>
                <span>{{ mediaStorage }}</span>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-12 d-flex row align-items-end mt-4">
        <div class="col-12 col-md-4 mb-3 mb-md-0">
          <label>{{ CompanyNamedisabled ? "Client" : "Select Client" }}</label>
          <el-select class="select__form__client w-100" size="large" placeholder="Select Client Name"
            v-model="selectedCompany" :disabled="CompanyNamedisabled" @change="onCompanyChange">
            <el-option v-for="option in companyList" :value="option.id" :label="option.company_name" :key="option.id">
            </el-option>
          </el-select>
        </div>
        <div class="col-12 col-md-5 mb-3 mb-md-0">
          <label class="d-none d-md-block">Search by Name</label>
          <el-input size="large" placeholder="Search media name..." prefix-icon="el-icon-search" v-model="searchQuery" clearable />
        </div>
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <label class="d-none d-md-block">Size</label>
          
          <div class="d-flex align-items-center"> <el-select v-model="activeDimensionFilter" size="large" placeholder="All sizes" class="w-100" filterable>
              
              <el-option label="All" value="all"></el-option>
              <el-option label="Available Only" value="available"></el-option>
              
              <el-option-group label="Specific Sizes">
                  <el-option
                    v-for="dim in allowedDims"
                    :key="`${dim.w}x${dim.h}`"
                    :label="`${dim.w} x ${dim.h}`"
                    :value="`${dim.w}x${dim.h}`"
                  />
              </el-option-group>

            </el-select>
            </div>
        </div>      
      </div>      
      
      <!-- Minimum Recommended Sizes Section -->
      <div class="col-sm-12 col-md-12 col-lg-12 mt-4 mb-3">
        <div class="recommended-sizes-section">
          <div class="recommended-sizes-header">
            <i class="el-icon-star-on" style="color: #409EFF; margin-right: 8px;"></i>
            <span class="recommended-sizes-title">Minimum Recommended Sizes</span>
          </div>
          <div class="recommended-sizes-description">
            <span>For optimal display performance and compatibility across all advertising platforms</span>
          </div>
          <div class="recommended-sizes-grid">
            <span class="size-badge">300×250</span>
            <span class="size-badge">728×90</span>
            <span class="size-badge">160×600</span>
            <span class="size-badge">300×600</span>
            <span class="size-badge">320×50</span>
            <span class="size-badge">300×50</span>
            <span class="size-badge">970×250</span>
            <span class="size-badge">250×250</span>
            <span class="size-badge">200×200</span>
          </div>
        </div>
      </div>
      
      <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
        <div class="d-flex align-items-center justify-content-between mb-2" style="height: 41px;">
          <span class="font-weight-600 text-dark" style="font-size: 14px;">Files</span>
          <div v-if="selectedItems.length">
            <el-button round @click="selectedItems = []" icon="el-icon-close">{{ selectedItems.length }} Selected</el-button>
            <el-button type="text" icon="el-icon-download" style="color: #000000; font-size: 16px;" @click="downloadSelected" />
            <el-button type="text" icon="el-icon-delete" style="color: #000000; font-size: 16px;" @click="handleDelete" />
          </div>
        </div>
        
      <div class="media-collection-wrapper">
        
        <div v-if="isLoadingMedia" class="state-container">
          <i class="el-icon-loading"></i>
          <span>Loading media...</span>
        </div>
        
        <div v-else-if="isLoadingMediaError" class="state-container">
          <i class="el-icon-warning-outline" style="color: #F56C6C;"></i>
          <span>Failed to load media. Please try again.</span>
        </div>

        <div v-else-if="!displayedGroups.length" class="state-container">
          <i class="el-icon-zoom-out"></i>
          <span>No media found matching your filters.</span>
        </div>


        <div v-else>
          <div 
            v-for="group in displayedGroups" 
            :key="group.dimensionKey" 
            class="media-dimension-group"
          >
            <div class="dimension-title">
              <div class="dimension-divider"></div>
              <div class="dimension-row">
                <span class="dimension-label">{{ group.w }} x {{ group.h }}</span>
                <span class="dimension-count">({{ group.media.length }} items)</span>
              </div>
            </div>
            <div class="media-collection-grid">
              <media-item 
                v-for="item in group.media"
                :key="item.id"
                :item="item"
                :selectedItems="selectedItems"
                :isDeleting="deletingIds.includes(item.id)"
                @select="selectItem(item)"
                @preview="openPreview(item)"
              />
              <div class="media-box placeholder" @click="openUpload(group)">
                <i class="el-icon-plus"></i>
                <span class="placeholder-label">Add {{ group.w }}x{{ group.h }}</span>
              </div>
            </div>
          </div>
        </div>        
      </div>     
      </div>

      <template slot="footer">
        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" style="gap:8px">
          <div style="font-size: 14px;">
            <span><strong>Note: </strong>Only .jpg, .png or .gif formats supported for display ad</span>
          </div>
          <div class="d-flex flex-row-reverse flex-wrap align-items-center" style="gap:8px">
            <base-button v-if="selectedItems.length" size="sm" style="height:40px" @click="addToCampaign">Add Media</base-button>
            <base-button @click="localOpen = false" simple size="sm" style="height:40px">Cancel</base-button>
          </div>
            <!-- Image Preview Dialog -->
            <el-dialog
              :visible.sync="previewOpen"
              :append-to-body="true"
              width="50%"
              custom-class="media-image-preview"
              :show-close="true"
            >
              <div v-if="previewItem" class="preview-body d-flex justify-content-center">
                <img :src="previewItem.media" :alt="previewItem.name" style="max-width:100%; max-height:70vh; border-radius:8px;" />
              </div>
              <span slot="title">{{ previewItem ? previewItem.name : 'Preview' }}</span>
            </el-dialog>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "src/components";
import {
  Select, Option, Upload, Button, Checkbox, Dropdown,Dialog,
  DropdownMenu,
  DropdownItem,
  Notification
} from "element-ui";
import { required } from "vee-validate/dist/rules";
import MediaItem from "./MediaItem.vue";
import { selection } from "d3";
import axios from 'axios';
import { mapActions } from "vuex/dist/vuex.common.js";
import { downloadMediaBackground } from '../../helpers/downloadFile';

export default {
  components: {
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dialog.name]: Dialog,
    MediaItem
  },
  data() {
    return {
      selectedCompany: "",
      fileList: [],
      selectedItems: [],
      searchQuery: "",
      allowedDims: [{"w":728,"h":90},{"w":160,"h":600},{"w":120,"h":600},{"w":120,"h":160},{"w":120,"h":240},{"w":120,"h":60},{"w":120,"h":90},{"w":125,"h":125},{"w":160,"h":90},{"w":180,"h":150},{"w":180,"h":90},{"w":200,"h":90},{"w":234,"h":60},{"w":240,"h":400},{"w":300,"h":100},{"w":300,"h":850},{"w":336,"h":280},{"w":450,"h":50},{"w":468,"h":15},{"w":468,"h":60},{"w":468,"h":728},{"w":728,"h":15},{"w":88,"h":31},{"w":700,"h":500},{"w":120,"h":20},{"w":168,"h":28},{"w":216,"h":36},{"w":320,"h":480},{"w":480,"h":320},{"w":768,"h":1024},{"w":1024,"h":768},{"w":320,"h":250},{"w":970,"h":250},{"w":200,"h":200},{"w":250,"h":250},{"w":320,"h":50},{"w":980,"h":120},{"w":980,"h":240},{"w":1250,"h":300},{"w":1250,"h":600},{"w":320,"h":320},{"w":250,"h":360},{"w":250,"h":600},{"w":250,"h":800},{"w":468,"h":250},{"w":600,"h":315},{"w":1200,"h":628},{"w":970,"h":90},{"w":640,"h":100},{"w":300,"h":400},{"w":468,"h":400},{"w":1400,"h":400},{"w":1920,"h":1080},{"w":1080,"h":1920},{"w":1224,"h":340},{"w":1920,"h":576},{"w":3840,"h":1080},{"w":1280,"h":360},{"w":840,"h":400},{"w":300,"h":250},{"w":300,"h":600},{"w":300,"h":50},{"w":500,"h":500},{"w":640,"h":640},{"w":1024,"h":1024}],
      mediaData: [],
      storageUsedBytes: 0,
      storageLimitBytes: 500 * 1024 * 1024,
      deletingIds: [],
      uploadTargetDim: null,
      previewOpen: false,
      previewItem: null,
      isLoadingMedia: false,
      isLoadingMediaError: false,
      displayedGroups: [],
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    CompanyNamedisabled: {
      type: Boolean,
      required: true
    },
    companySelected: {
      type: String,
      required: true
    },
    companyList: {
      type: Array,
      required: true
    },
    activeDimensionFilter:{
      type: String,
      default: 'all'
    }
  },
  computed: {
    localOpen: {
      get() {
        this.selectedCompany = this.companySelected;
        this.selectedItems = [];
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    storageUsedMB() {
      return (this.storageUsedBytes / 1024 / 1024).toFixed(2); // bytes -> MB
    },
    storageLimitMB() {
      return (this.storageLimitBytes / 1024 / 1024).toFixed(0);
    },
    mediaStorage() {
      return `${this.storageUsedMB}MB/${this.storageLimitMB}MB`;
    },
  },
  watch: {
    searchQuery() {
      this.updateFilteredGroups();
    },
    activeDimensionFilter() {
      this.updateFilteredGroups();
    },
    async value(newValue) {
      if (newValue) {
        // Reset filter setiap kali modal dibuka
        this.isLoadingMedia = true;
        this.activeDimensionFilter = this.$props.activeDimensionFilter;
        this.searchQuery = '';
        this.selectedCompany = this.companySelected;
        this.selectedItems = [];
        this.initializeData();
      }
    },

  },
  mounted() {
    this.selectedCompany = this.companySelected;
    this.selectedItems = [];
  },
  methods: {
    ...mapActions(['SimplifiGetMedia','GetDownloadMediaToken']),
    async initializeData() {
      await this.getMedia();
    },
    updateFilteredGroups() {
      const query = this.searchQuery.toLowerCase().trim();
      let processedGroups = this.allowedDims.map(dim => {
        const mediaInDim = this.mediaData.filter(item => this.matchDimension(item, dim));
        return {
          ...dim,
          dimensionKey: `${dim.w}x${dim.h}`,
          media: mediaInDim,
        };
      });
      if (this.activeDimensionFilter === 'available') {
        processedGroups = processedGroups.filter(group => group.media.length > 0);
      } else if (this.activeDimensionFilter !== 'all') {
        processedGroups = processedGroups.filter(group => group.dimensionKey === this.activeDimensionFilter);
      }
      if (query) {
        processedGroups = processedGroups.map(group => ({
          ...group,
          media: group.media.filter(item => (item.name || '').toLowerCase().includes(query)),
        }));
        processedGroups = processedGroups.filter(group => group.media.length > 0);
      }

      // Sort groups by dimensions (width first, then height)
      processedGroups.sort((a, b) => {
        if (a.w !== b.w) {
          return a.w - b.w; // Sort by width first
        }
        return a.h - b.h; // Then by height
      });

      this.displayedGroups = processedGroups;
    },
    matchDimension(item, dim) {
      if (!item || !item.dimensions || !dim) return false;
      return item.dimensions.replace(/\s/g, '') === `${dim.w}x${dim.h}`;
    },
    openUpload(dim) {
      this.uploadTargetDim = dim;
      this.$refs.upload.$el.querySelector('input').click();
    },
    onCompanyChange() {
      this.isLoadingMedia = true;
      this.searchQuery = '';
      this.activeDimensionFilter = 'all';
      this.getMedia();
    },
    async getMedia() {
      this.isLoadingMediaError = false;
      try {
        if (!this.selectedCompany) {
          this.mediaData = [];
          return; 
        }
        let selectedCompanyItem = this.companyList.find(item => item.id == this.selectedCompany);
        
        if (!selectedCompanyItem) {
          selectedCompanyItem = this.companyList.find(item => item.company_name == this.selectedCompany);
        }
        const user_id = selectedCompanyItem ? selectedCompanyItem.id : null;
        if (!user_id) {
          this.mediaData = [];
        } else {
          const payloadGetMedia = { user_id };
          const response = await this.SimplifiGetMedia({ data: payloadGetMedia });
          
          if (response.result === 'success') {
            this.mediaData = response.media || [];
            this.storageUsedBytes = response.occupied_storage;
          } else {
            this.mediaData = [];
            this.isLoadingMediaError = true; 
          }
        }
      } catch (error) {
        this.isLoadingMediaError = true;
        this.mediaData = [];
      } finally {
        this.updateFilteredGroups();
        this.isLoadingMedia = false;
      }
    },
    noopUpload() {
      // Required by Element UI; can be empty
      return;
    },
    handleChange(file) {
      let selectedCompanyItem = this.companyList.find(item => item.id == this.selectedCompany);
      if (!selectedCompanyItem) {
        selectedCompanyItem = this.companyList.find(item => item.company_name == this.selectedCompany);
      }
      const user_id = selectedCompanyItem ? selectedCompanyItem.id : null;
      if(!user_id) {
        this.$notify({ 
          type: 'danger', 
          message: 'User ID not found.', 
          icon: 'fas fa-bug'
        });
        return;
      }

      const loadingNotification = Notification({
        message: `
          <p style="color: #000; font-size: 20px; font-weight: bold;">
          <i class="el-icon-loading" style="margin-right: 10px;"></i> Uploading Media...
          </p>
          <p style="color: #000; font-size: 14px; margin-top: 10px;">
            We're Uploading your media.
          </p>
        `,
        duration: 0,
        dangerouslyUseHTMLString: true,
      });      

      const reader = new FileReader();
      reader.onload = e => {
        const img = new Image();
        img.onload = () => {
          const { width, height } = img;
        if (this.uploadTargetDim) {
          if (width !== this.uploadTargetDim.w || height !== this.uploadTargetDim.h) {
            loadingNotification.close()
            this.$notify({
              type: 'danger',
              message: `Image must be exactly ${this.uploadTargetDim.w}x${this.uploadTargetDim.h}, but the selected file is ${width}x${height}.`,
              icon: 'fas fa-exclamation-triangle'
            });
            this.uploadTargetDim = null;
            return;
          }
        } else {
          const isValid = this.allowedDims.some(d => d.w === width && d.h === height);
          if (!isValid) {
            loadingNotification.close()
            this.$notify({
              type: 'danger',
              message: `Invalid dimension ${width}x${height}.<br> Valid dimensions: ${this.allowedDims.map(d => d.w + "x" + d.h).join(", ")}`,
              icon: 'fas fa-bug'
            });
            const idx = this.fileList.findIndex(f => f.uid === file.uid);
            if (idx !== -1) this.fileList.splice(idx, 1);
            return;
          }
        }

          const formData = new FormData();
          formData.append('user_id', user_id);
          formData.append('file', file.raw);


          axios.post(process.env.VUE_APP_APISERVER_URL + '/api/media/upload', formData)
            .then(() => {
              this.getMedia();
              loadingNotification.close()
              this.$notify({
                type: 'success',
                message: 'Upload successful!',
                icon: 'fas fa-check-circle'
              });
            })
            .catch(error => {
              const message = error.response.data.message || 'Something went wrong.';
              loadingNotification.close()
              this.$notify({
                type: 'danger', message, icon: 'fas fa-exclamation-triangle'
              });
            })
            .finally(() => {
              this.uploadTargetDim = null;
            });
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file.raw);
    },
    async handleDelete() {
      if (!this.selectedItems.length) return;
      const selectedIds = this.selectedItems.map(item => item.id);
      this.deletingIds = [...this.deletingIds, ...selectedIds];
      try {
        const formData = new FormData();
        formData.append('media_ids', selectedIds);
        await axios.post(`${process.env.VUE_APP_APISERVER_URL}/api/media/delete`, formData);
        await this.getMedia();
        this.$notify({
          type: 'success',
          message: 'Selected media deleted successfully!',
          icon: 'fas fa-check-circle'
        });
        this.selectedItems = [];
      } catch (error) {
        const message = error.response.data.message || 'Failed to delete media.';
        this.$notify({
          type: 'danger', message, icon: 'fas fa-exclamation-triangle'
        });
      } finally {
        this.deletingIds = this.deletingIds.filter(id => !selectedIds.includes(id));
      }
    },
    async downloadSelected() {
        if (!this.selectedItems.length) return;

        const media_ids = this.selectedItems.map(item => item.id);
        const payload = { data: { media_ids } };
        const response = await this.GetDownloadMediaToken(payload);
        if (response.token) {
          try {
              const url = `${process.env.VUE_APP_DATASERVER_URL}/download-media/${response.token}`;
              const fileName = this.selectedItems.length === 1 
                  ? this.selectedItems[0].name
                  : 'selected-files.zip';
              downloadMediaBackground(url, fileName);
          } catch (err) {
              console.error("Failed to download:", err);
          }
        } else {
          this.$notify({
            type: 'danger',
            message: 'Failed to get download token.',
            icon: 'fas fa-exclamation-triangle'
          });
        }
    },
    selectItem(item) {
      const index = this.selectedItems.findIndex(i => i.id === item.id);
      (index !== -1) ? this.selectedItems.splice(index, 1) : this.selectedItems.push(item);
    },
    addToCampaign(){
      this.$emit('selected-media', this.selectedItems);
    },
    openPreview(item) {
      console.log('openPreview', item);
      
      this.previewItem = item;
      this.previewOpen = true;
    },
  },
};
</script>

<style lang="scss">
.media-preview-dialog {
  .el-message-box__content { padding: 0 0 12px; }
  .el-message-box__headerbtn { top: 8px; right: 8px; }
}

.media-image-preview {
  .el-dialog__title {
    color: #111827 !important;
    font-weight: 700 !important;
    letter-spacing: .2px;
  }
  .el-dialog__header { color: #111827 !important; }
}
.audiance-upload .el-upload-dragger {
  width: 100%;
}

.audiance-upload .el-upload {
  width: 100%;
}

.media-collection-wrapper {
  max-height: 490px;
  overflow-y: auto;
  padding: 0 15px 15px;
}

// .media-collection-grid {
//   display: grid;
//   margin-top: 16px;
//   position: unset !important;
//   gap: 1.5rem;
//   grid-template-columns: repeat(4, minmax(0, 1fr));
// }

.rounded-lg {
  border-radius: 0.5rem;
}

.audiance-upload .el-upload { width: 100%; }
+
.media-dimension-group {
  margin-bottom: 40px;
}

.dimension-title {
  position: relative;
  background: transparent;
  padding: 0;
  margin: 8px 0 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .dimension-row {
    display: inline-flex;
    align-items: baseline;
    gap: 8px;
  }

  .dimension-label {
    font-weight: 700;
    font-size: 14px;
    color: #1f2937; /* gray-800 */
  }

  .dimension-count {
    font-size: 12px;
    color: #6b7280; /* gray-500 */
    margin-left: 0;
  }

  // dotted divider below the label row
  .dimension-divider {
    width: 100%;
    height: 0;
    border-bottom: 1px dotted #d1d5db; /* gray-300 */
  }
}

.media-collection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
}

.media-box {
  width: 100%;
  aspect-ratio: 1 / 1;    /* Selalu kotak */
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.placeholder {
  background: linear-gradient(135deg, #f5f7fa 0%, #e9eef5 100%);
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px dashed #c5d1e0;
  gap: 8px;
}

.placeholder:hover {
  background: linear-gradient(135deg, #edf5ff 0%, #e3ecf7 100%);
  border-color: #6aa3ff;
  color: #2a6bf4;
  transform: translateY(-2px);
}

.placeholder i {
  font-size: 24px;
}

.placeholder .placeholder-label {
  font-size: 12px;
  font-weight: 600;
}

.state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
  text-align: center;
  
  i {
    font-size: 48px;
    margin-bottom: 16px;
  }

  span {
    font-size: 14px;
  }
}

// Recommended Sizes Section Styles
.recommended-sizes-section {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
}

.recommended-sizes-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.recommended-sizes-title {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
}

.recommended-sizes-description {
  margin-bottom: 12px;
}

.recommended-sizes-description span {
  font-size: 12px;
  color: #64748b;
  font-style: italic;
}

.recommended-sizes-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.size-badge {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 11px;
  font-weight: 400;
  color: #64748b;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  cursor: default;
  user-select: none;
}

// RESPONSIVE FILE MOBILE BREAKPOINSTS
@media (max-width: 767.98px) {
  .media-collection-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  
  .recommended-sizes-grid {
    gap: 6px;
  }
  
  .size-badge {
    font-size: 10px;
    padding: 3px 6px;
  }
}
</style>
